export var UTMUtils = {
    isAudienceMarkerContainsUTM: function (audienceMarkerMeta) {
        return (!!audienceMarkerMeta.utm_source ||
            !!audienceMarkerMeta.utm_medium ||
            !!audienceMarkerMeta.utm_campaign);
    },
    audienceMarkerUtils: {
        // @note: Accordingly to confluence document
        // https://confluence.atl.finanzcheck.de/display/SMF/UTM+switch
        // to avoid specific characters in audienceMarker strings
        makeUTMParamSign: function (type, value) {
            var valueToPass = typeof value === 'undefined' ? 'null' : value.replace(/_/g, '');
            return "utmxxx".concat(type).concat(valueToPass);
        },
        makeAudienceMarker: function (audienceMarkerMeta) {
            var placementId = audienceMarkerMeta.placementId, utm_campaign = audienceMarkerMeta.utm_campaign, utm_medium = audienceMarkerMeta.utm_medium, utm_source = audienceMarkerMeta.utm_source;
            var shouldUsePID = typeof placementId !== 'undefined';
            var shouldUseUTM = UTMUtils.isAudienceMarkerContainsUTM(audienceMarkerMeta);
            if (!shouldUseUTM && !shouldUsePID) {
                return null;
            }
            if (!shouldUseUTM) {
                return placementId;
            }
            return [
                UTMUtils.audienceMarkerUtils.makeUTMParamSign('s', utm_source),
                UTMUtils.audienceMarkerUtils.makeUTMParamSign('m', utm_medium),
                UTMUtils.audienceMarkerUtils.makeUTMParamSign('c', utm_campaign),
            ].join('');
        },
    },
};
